var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { Angulartics2 } from 'angulartics2';
import { Angulartics2Mixpanel as _Angulartics2Mixpanel } from 'angulartics2/mixpanel';
var Angulartics2Mixpanel = /** @class */ (function (_super) {
    __extends(Angulartics2Mixpanel, _super);
    function Angulartics2Mixpanel(angulartics2) {
        var _this = _super.call(this, angulartics2) || this;
        _this.ingnoredEvents = {
            SignInSuccess: true
        };
        _this.eventMapping = {
            RegistrationSuccess: 'Registration'
        };
        return _this;
    }
    Angulartics2Mixpanel.prototype.eventTrack = function (action, properties) {
        if (this.ingnoredEvents[action]) {
            return;
        }
        if (this.eventMapping[action]) {
            properties = Object.assign({}, properties);
            if (properties.event === action) {
                properties.event = this.eventMapping[action];
            }
            action = this.eventMapping[action];
        }
        _super.prototype.eventTrack.call(this, action, properties);
    };
    Angulartics2Mixpanel.prototype.setUsername = function (userId) {
        _super.prototype.setUsername.call(this, userId && userId.toLowerCase());
    };
    Angulartics2Mixpanel.prototype.setUserProperties = function (properties) {
        var e_1, _a;
        if ('email' in properties) {
            window.mixpanel.reset();
            properties.email = properties.email && properties.email.toLowerCase();
        }
        var props = Object.assign({}, properties);
        var superProperties = {
            'email': '$email',
            'firstName': '$first_name',
            'lastName': '$last_name',
            'productInterestTemp': 'Product Interest',
            'country': 'Selected Country',
            'phone': '$phone',
            'unsubscribed': '$unsubscribed',
            'hasTenant': 'Has Tenant',
            'isTest': 'IsTest'
        };
        try {
            for (var _b = __values(Object.keys(superProperties)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var oldKey = _c.value;
                if (oldKey in props) {
                    var newKey = superProperties[oldKey];
                    props[newKey] = props[oldKey];
                    delete props[oldKey];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        _super.prototype.setUserProperties.call(this, props);
    };
    return Angulartics2Mixpanel;
}(_Angulartics2Mixpanel));
export { Angulartics2Mixpanel };
